import { useEffect, useState } from "react";
import { Button, Form, Label } from "reactstrap";
import getExportUMO from "../services/getExportUMO";
import useAxios from "../../../../Utils/useAxios";
import FormModal from "../../../../Layout/Components/FormModal";
import { DateInputField, SelectionField } from "../../../../CommonElements";
import { getUnitKerja } from "../services";
import { toast } from "react-toastify";
import { getItemCreateSuccessMsg } from "../../../../Constant/Message";
import { timeToast } from "../../../../Constant";

const ExportUMO = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [unitKerjaOption, setUnitKerjaOption] = useState([
    {
      pk: 0,
      nama_unit_kerja: "Semua",
    },
  ]);
  const [formData, setFormData] = useState({
    id_status_umo: 0,
    id_unit_kerja: 0,
    dari_tanggal: "",
    sampai_tanggal: "",
    // untuk_tanggal: "",
    // batas_akhir: "",
  });
  const axiosInstance = useAxios();
  const toggleModal = () => setModalOpen(!modalOpen);
  
  const resetForm = () => {
    setFormData({
      id_status_umo: 0,
      id_unit_kerja: 0,
      dari_tanggal: "",
      sampai_tanggal: "",
      // untuk_tanggal: "",
      // batas_akhir: "",
    });
  };

  const getDocument = () => {
    setWaitingForSubmit(true);
    getExportUMO(axiosInstance, formData).then((res) => {
      const filename = res.headers["content-disposition"]
        .split("filename=")[1]
        .replace(/['"]/g, "");
      const file = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileURL = URL.createObjectURL(file);
      const dom = document.createElement("a");
      dom.setAttribute("style", "display:none");
      dom.setAttribute("href", fileURL);
      dom.setAttribute("target", "_blank");
      dom.setAttribute("download", filename);
      document.body.appendChild(dom);
      dom.click();
      resetForm();
      toggleModal();
      setWaitingForSubmit(false);
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(dom);
      toast.success(getItemCreateSuccessMsg("Tanda Terima"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      return res;
    });
  };

  useEffect(() => {
    unitKerja();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if ( name === 'dari') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormData((prev) => ({
        ...prev,
        'sampai': '' 
      }))
    } else if (name === 'sampai') {
 
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const unitKerja = () => {
    getUnitKerja(axiosInstance).then((res) => {
      setUnitKerjaOption((prev) => [...prev, ...res.data]);
      console.log(res.data);
    });
  };

  const statusOption = [
    {
      id: 0,
      nama_status_umo: "Semua",
    },
    {
      id: 1,
      nama_status_umo: "Baru Diajukan",
    },
    {
      id: 2,
      nama_status_umo: "Dipertanggung Jawabkan",
    },
    {
      id: 3,
      nama_status_umo: "Diverifikasi",
    },
    {
      id: 4,
      nama_status_umo: "Dibayarkan",
    },
    {
      id: 5,
      nama_status_umo: "Ditolak",
    },
  ];

  return (
    <>
      <Button onClick={toggleModal}>Export UMO</Button>
      <FormModal
        title={"Export UMO"}
        isOpen={modalOpen}
        toggle={toggleModal}
        footerButtons={
          <>
            <Button
              color={"primary"}
              onClick={getDocument}
              disabled={waitingForSubmit}
            >
              {waitingForSubmit ? "Memuat" : "Export"}
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
          </>
        }
      >
        <Form>
          <SelectionField
            state={formData}
            label={"Unit Kerja"}
            name={"id_unit_kerja"}
            onChange={handleChange}
            options={unitKerjaOption}
            optionsValue={"pk"}
            optionsName={"nama_unit_kerja"}
          />
          <SelectionField
            state={formData}
            label={"Status"}
            name={"id_status_umo"}
            onChange={handleChange}
            options={statusOption}
            optionsValue={"id"}
            optionsName={"nama_status_umo"}
          />
          <Label className={"bg-transparent mt-4"}>
            Untuk Tanggal
          </Label>
          <div className="d-flex flex-row justify-content-between">
            <DateInputField
              state={formData}
              label={"Dari"}
              name={"dari_tanggal"}
              onChange={handleChange}
              value={formData.dari_tanggal}
            />
            <DateInputField
              state={formData}
              label={"Sampai"}
              name={"sampai_tanggal"}
              onChange={handleChange}
              value={formData.sampai_tanggal}
              min={formData.dari_tanggal}
              disabled={formData.dari_tanggal === '' ? true : false}
            />
          </div>
        </Form>
      </FormModal>
    </>
  );
};

export default ExportUMO;
